import { factoryService, postJsonRequest } from '@chilecompra/react-kit/requests'
import { REACT_APP_API_BASE_URL } from '../config/settings/environment'

/**
 * Unsubscribe mailings.
 */
export const unsubscribe = factoryService(({ qs }) =>
  postJsonRequest(`${REACT_APP_API_BASE_URL}/v1/public/mailing/unsubscribe?qs=${qs}`, { isPublic: true })
)
